var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectHeaderRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.228 52.1033L61.4681 63.3433C67.7954 69.6706 68.1621 80.0211 61.9374 86.461C55.5279 93.0858 44.923 93.0811 38.5191 86.4614C34.7059 82.525 33.4032 76.9545 34.4627 71.8049C35.1046 68.6721 36.6313 65.7 38.9886 63.3427L50.228 52.1033Z",
    fill: "#FFC832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.97 49.3611L64.21 38.1211C70.5373 31.7937 80.8878 31.427 87.3277 37.6517C93.9525 44.0612 93.9478 54.6661 87.3281 61.07C83.3917 64.8832 77.8212 66.1859 72.6716 65.1264C69.5388 64.4845 66.5667 62.9578 64.2094 60.6005L52.97 49.3611Z",
    fill: "#0096FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6792 46.0703L60.9192 34.8303C67.2465 28.503 67.6133 18.1525 61.3886 11.7126C54.979 5.08776 44.3742 5.09252 37.9702 11.7122C34.1571 15.6486 32.8544 21.2191 33.9138 26.3686C34.5557 29.5015 36.0825 32.4736 38.4398 34.8309L49.6792 46.0703Z",
    fill: "#FF3CA0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectHeaderRight);
export default __webpack_public_path__ + "static/media/connectHeaderRight.40f7a0893388f57ab5027c910979b2c1.svg";
export { ForwardRef as ReactComponent };